/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)
import './styles/app.scss';
import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;

// start the Stimulus application
// var $ = require('jquery');
// var $ = require('./js/jquery-3.6.0.min');
//

window.jQuery = $;
window.$ = $;



// import SlideForm from './ts/MultiScreenSlideForm';
import Rapheal from "./../node_modules/raphael/raphael.js";
import PapaParse from "./../node_modules/papaparse";
import './../node_modules/popper.js';
// import Rapheal from "./js/raphael-min";
window.Raph = Rapheal;
window.PapaParse = PapaParse;
require("./ts/app.ts");
// console.log(window.Raph);
// console.log(window.MultiScreenSlideForm);
// console.log(window.FormSlide);
// console.log(window.SlideHolder);
// console.log(window.FormConfig);
require('bootstrap');

require('./js/custom.js');
require('./js/jquery.validate.min');
require('./js/fontawesome-all.min.js');
require('./js/dropdownselect.js');
// require('./js/formslider.js');
require('./js/AnimatedInput.js');
require('./js/CustomSelect.js');
require('./js/CustomInput.js');
require('./js/chart.js');
require('./js/startanimation.js');
require('./js/slider.js');
require('./js/mobileMenu.js');
import './js/bootstrap';
import MultiScreenSlideForm from "./ts/MultiScreenSlideForm";

